webpackJsonp([2],{

/***/ "0au2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacy_policy__ = __webpack_require__("5SCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__terms_of_service__ = __webpack_require__("iu14");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common__ = __webpack_require__("1lyH");
stateConfiguration.$inject = ['$stateProvider'];







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('legal.scene', [__WEBPACK_IMPORTED_MODULE_1__privacy_policy__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__terms_of_service__["a" /* default */].name]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('landing', {
        url: Object(__WEBPACK_IMPORTED_MODULE_3_common__["i" /* getPresentationStateUrl */])(),
        data: {
            external: {
                blank: true
            }
        }
    });
}

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("9Jvq");


/***/ }),

/***/ "5SCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_state__ = __webpack_require__("oOqA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_policy_cmpt__ = __webpack_require__("gw0C");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('legal.scene.privacy-policy', []).component(__WEBPACK_IMPORTED_MODULE_2__privacy_policy_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__privacy_policy_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('privacy-policy', {
        url: __WEBPACK_IMPORTED_MODULE_1_common_state__["b" /* URL_PRIVACY_POLICY */],
        component: __WEBPACK_IMPORTED_MODULE_2__privacy_policy_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "9Jvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__ = __webpack_require__("7Cuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_site_style_sass__ = __webpack_require__("rdqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_site_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_site_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scene__ = __webpack_require__("0au2");
routerConfiguration.$inject = ['$locationProvider', '$urlRouterProvider'];








/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('legal', [__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__["default"], __WEBPACK_IMPORTED_MODULE_3_common__["f" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__scene__["a" /* default */].name]).config(routerConfiguration));

/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/privacy-policy');
}

/***/ }),

/***/ "HJbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_of_service_tpl_pug__ = __webpack_require__("XIB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_of_service_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__terms_of_service_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var TermsOfServiceController = function () {
    TermsOfServiceController.$inject = ['$state', 'configuration'];

    /* @ngInject */
    function TermsOfServiceController($state, configuration) {
        _classCallCheck(this, TermsOfServiceController);

        this.$state = $state;
        this.configuration = configuration;
    }

    _createClass(TermsOfServiceController, [{
        key: '$onInit',
        value: function $onInit() {
            this.salesEmail = this.configuration.salesEmail;
            this.landingUrl = this.$state.href('landing');
        }
    }]);

    return TermsOfServiceController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbLTermsOfService',
    template: __WEBPACK_IMPORTED_MODULE_0__terms_of_service_tpl_pug___default()(),
    controller: TermsOfServiceController
});

/***/ }),

/***/ "XIB7":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["title"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ch1 class=\"title\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fh1\u003E";
};
pug_mixins["subtitle"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ch2 class=\"subtitle\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fh2\u003E";
};
pug_mixins["paragraph"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cp class=\"paragraph\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fp\u003E";
};
pug_mixins["list"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cul class=\"list\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Ful\u003E";
};
pug_mixins["list-item"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"list-item\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fli\u003E";
};






pug_mixins["footer"] = pug_interp = function(date){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cfooter class=\"footer\"\u003ELast Modified: " + (pug.escape(null == (pug_interp = date) ? "" : pug_interp)) + "\u003C\u002Ffooter\u003E";
};
pug_html = pug_html + "\u003Cdiv id=\"terms-of-service-page\"\u003E";
pug_mixins["title"].call({
block: function(){
pug_html = pug_html + "Dollarbird Terms of Service";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "1. Introduction";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "These Terms and Conditions (\"Terms\", \"Terms and Conditions\") govern your relationship with the \u003Ca href=\"javascript:void(0);\" ui-sref=\"landing\" ng-bind=\"$ctrl.landingUrl\"\u003E\u003C\u002Fa\u003E website and the Dollarbird mobile application (the \"Service\") operated by Dollarbird Apps SRL (\"us\", \"we\", or \"our\").";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Please read these Terms and Conditions carefully before using our website and\u002For the Dollarbird mobile application (the \"Service\").";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "2. How Dollarbird works";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird is a cloud-based personal finance management platform available on iOS, Android and web. It helps users to track their expenses and incomes, forecast their cash- flow and plan future transactions. Users can also invite other users to collaborate in Teams on shared calendars and manage their finances together. No bank account information is needed, all data is manually added to Dollarbird by the users.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "3. Nature of service";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird believes that its Service is useful for the management of personal finances. However, our Service is no replacement for a professional accountant or financial adviser, and may not be useful to you or accurate for your particular circumstances. You agree that you are solely responsible for determining whether the use of our Service is right for you, and you agree to release Dollarbird from any liability relating to your use of our Service.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "4. Rules of Use";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "You must not:";
}
});
pug_mixins["list"].call({
block: function(){
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Violate the laws of Romania, the European Union, the United States, its states, or any foreign political entity having jurisdiction over this Agreement, whether or not the foreign political entity is a country or a subdivision (such as a state or province) or municipality (such as a city, town, county, or region) of a foreign country.";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Post or send anything violent, threatening, pornographic, racist, hateful, or otherwise objectionable according to the opinion of Dollarbird or its delegates.";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Infringe on anyone’s intellectual property rights, defame anyone, impersonate anyone, or otherwise violate the rights of a third party.";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Hack, crack, phish, SQL inject, or otherwise compromise the security or integrity of the Dollarbird website, app, service, or its users’ computers or mobile devices.";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Do anything else which could bring Dollarbird into disrepute or violate the rights of any person.";
}
});
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "5. Subscriptions";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Some parts of the Service are billed on a subscription basis (\"Subscription(s)\"). You will be billed in advance on a recurring and periodic basis (\"Billing Cycle\"). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Payment will be processed by third party providers, depending on the device you’re purchasing a Subscription occurs on:";
}
});
pug_mixins["list"].call({
block: function(){
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Apple App Store on iOS";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Google Play Store on Android";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Avangate on web";
}
});
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We strongly advise you to read the terms and conditions and privacy policies of the third party payment providers, before purchasing a subscription, as applicable to your device.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or Dollarbird Apps SRL cancels it. You may cancel your Subscription renewal either through your online account management page, through the Apple App Store or Google Play Store (as applicable).";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "6. Fee Changes";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird Apps SRL, in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then- current Billing Cycle.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird Apps SRL will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "7. Refunds";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird Apps SRL is not responsible for handling refund requests. Please consult the refund policies of the Apple App Store, Google Play Store, or Avangate, as applicable.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "8. Accounts";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trade mark that is subject to any rights of another person or entity other than you without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "9. Intellectual Property";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "The Service and its original content, features and functionality are and will remain the exclusive property of Dollarbird Apps SRL and its licensors. The Service is protected by copyright, trademark, and other laws of both the Romania and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Dollarbird Apps SRL.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "10. Links To Other Web Sites";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Our Service may contain links to third-party web sites or services that are not owned or controlled by Dollarbird Apps SRL.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird Apps SRL has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Dollarbird Apps SRL shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We strongly advise you to read the terms and conditions and privacy policies of any third- party web sites or services that you visit.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "11. Limitation Of Liability";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "In no event shall Dollarbird Apps SRL, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "12. Disclaimer";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Your use of the Service is at your sole risk. The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird Apps SRL its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "13. Governing Law";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "These Terms shall be governed and construed in accordance with the laws of Romania, without regard to its conflict of law provisions.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "14. Force Majeure";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "You agree that we are not responsible to you for anything that we may otherwise be responsible for, if it is the result of events beyond our control, including, but not limited to, acts of God, war, insurrection, riots, terrorism, crime, labor shortages (including lawful and unlawful strikes), embargoes, postal disruption, communication disruption, unavailability of payment processors, failure or shortage of infrastructure, shortage of materials, or any other event beyond our control.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "15. Termination & Cancellation";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We may terminate your access to our Site and Service at our discretion without explanation, though we will strive to provide a timely explanation in most cases. Our liability for refunding you, if you have paid anything to us, will be limited to the amount you paid for goods or services which have not yet been and will not be delivered, except in cases where the termination or cancellation was due to your breach of this Agreement, in which case you agree that we are not required to provide any refund or other compensation whatsoever.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Under no circumstances, including termination or cancellation of our Service to you, will we be liable for any losses related to actions of other users.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "16. Changes";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "17. Contact Us";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "If you have any questions about these Terms, please contact us by sending an email to \u003Ca db-mail-to=\"$ctrl.salesEmail\" ng-bind=\"$ctrl.salesEmail\"\u003E\u003C\u002Fa\u003E.";
}
});
pug_mixins["footer"]("Aug 18, 2021");
pug_html = pug_html + "\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "gw0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_policy_tpl_pug__ = __webpack_require__("mWkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_policy_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__privacy_policy_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PrivacyPolicyController = function () {
    PrivacyPolicyController.$inject = ['$state', 'configuration'];

    /* @ngInject */
    function PrivacyPolicyController($state, configuration) {
        _classCallCheck(this, PrivacyPolicyController);

        this.$state = $state;
        this.configuration = configuration;
    }

    _createClass(PrivacyPolicyController, [{
        key: '$onInit',
        value: function $onInit() {
            this.salesEmail = this.configuration.salesEmail;
            this.landingUrl = this.$state.href('landing');
        }
    }]);

    return PrivacyPolicyController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbLPrivacyPolicy',
    template: __WEBPACK_IMPORTED_MODULE_0__privacy_policy_tpl_pug___default()(),
    controller: PrivacyPolicyController
});

/***/ }),

/***/ "iu14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_state__ = __webpack_require__("oOqA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__terms_of_service_cmpt__ = __webpack_require__("HJbV");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('legal.scene.terms-of-service', []).component(__WEBPACK_IMPORTED_MODULE_2__terms_of_service_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__terms_of_service_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('terms-of-service', {
        url: __WEBPACK_IMPORTED_MODULE_1_common_state__["e" /* URL_TERMS_OF_SERVICE */],
        component: __WEBPACK_IMPORTED_MODULE_2__terms_of_service_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "mWkH":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["title"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ch1 class=\"title\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fh1\u003E";
};
pug_mixins["subtitle"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ch2 class=\"subtitle\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fh2\u003E";
};
pug_mixins["paragraph"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cp class=\"paragraph\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fp\u003E";
};
pug_mixins["list"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cul class=\"list\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Ful\u003E";
};
pug_mixins["list-item"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"list-item\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fli\u003E";
};






pug_mixins["footer"] = pug_interp = function(date){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cfooter class=\"footer\"\u003ELast Modified: " + (pug.escape(null == (pug_interp = date) ? "" : pug_interp)) + "\u003C\u002Ffooter\u003E";
};
pug_html = pug_html + "\u003Cdiv id=\"privacy-policy-page\"\u003E";
pug_mixins["title"].call({
block: function(){
pug_html = pug_html + "Dollarbird Privacy Policy";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "1. Introduction";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + " Dollarbird Apps SRL (\"us\", \"we\", or \"our\") operates the \u003Ca href=\"javascript:void(0);\" ui-sref=\"landing\" ng-bind=\"$ctrl.landingUrl\"\u003E\u003C\u002Fa\u003E website and the Dollarbird mobile application (the \"Service\").";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We will not use or share your information with anyone except as described in this Privacy Policy.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "2. Information Collection And Use";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address, name, password, and any other information that we deem necessary for the purpose of providing you with our Service or which you provide to us voluntarily (\"Personal Information\").";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "3. Log Data";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device (\"Log Data\").";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "This Log Data may include information such as your computer's Internet Protocol (\"IP\") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "When you access the Service by or through a mobile device, this Log Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use and other statistics.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service's functionality. These third party service providers have their own privacy policies addressing how they use such information.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "4. Location information";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We may use and store information about your location, if you give us permission to do so. We use this information to provide features of our Service, to improve and customize our Service. You can enable or disable location services when you use our Service at anytime, through your mobile device settings.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "5. Cookies";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use \"cookies\" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Dollarbird and our analytics partners, use technologies such as cookies, beacons, tags, and scripts to enable a service to recognize your device so you don't have to provide the same information several times during one task, recognize that you may have already given a username and password so you don't need to do it for every web page requested, and measuring how many people are using services.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use local storage, such as HTML5, to store content information and preferences. Third parties with whom we partner to provide certain features also use HTML5 to collect and store information. Various browsers may offer their own management tools for removing HTML5.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We partner with third parties, such as Facebook and Google, to manage our advertising of the Products on other sites or platforms as well as across your other devices based on your past visits to our website. Our third party partners may use technologies such as cookies to gather information about your activities within the Products to deliver such advertising to you, such as retargeting ads.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use third party trackers to let us know when users have visited the Products by “clicking-through” our sponsored advertising or content hosted on third party platforms.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use Google Analytics code to gather statistical information. Google Analytics sets cookies to help us accurately estimate the number of visitors to Dollarbird and the volumes of usage of Dollarbird. For more information on how Google Analytics processes this information, visit \u003Ca href=\"https:\u002F\u002Fwww.google.com\u002Fanalytics\" target=\"_blank\" rel=\"noopener\"\u003Ewww.google.com\u002Fanalytics\u003C\u002Fa\u003E.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "6. Mobile Analytics";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We use mobile analytics software to allow us to better understand the functionality of our mobile software on your phone. This software may record information such as how often you use the mobile application, the events that occur within the application, aggregated usage, performance data, and where the application was downloaded from. We may link the information we store within the analytics software to any personal information you submit within the mobile application.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "7. Accessing, Editing, and Removing Your Information";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Users may in some cases be able to review and edit the personal information they have provided to us by logging into your account on the Site and editing their account. Although most changes may occur immediately, information may still be stored in a web browser’s cache. We take no responsibility for stored information in your cache, or in other devices that may store information, and disclaim all liability of such. In addition, we may, from time to time, retain residual information about you in our backup and\u002For database.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "8. Service Providers";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. For this reason, you hereby agree that for every authorization which you grant to us in this Privacy Policy, you also grant to any third party that we may hire, contract, or otherwise retain the services of for the purpose of operating, maintaining, repairing, or otherwise improving or preserving our website or its underlying files or systems. You agree not to hold us liable for the actions of any of these third parties, even if we would normally be held vicariously liable for their actions, and that you must take legal action against them directly should they commit any tort or other actionable wrong against you. Without limiting the generality of the foregoing, you authorize us to collect, share, store, exchange, and otherwise use your information in conjunction with:";
}
});
pug_mixins["list"].call({
block: function(){
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Apple App Store";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Google Play Store";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Avangate";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Flurry Analytics";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Google Analytics";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Firebase";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "MailChimp";
}
});
pug_mixins["list-item"].call({
block: function(){
pug_html = pug_html + "Calq";
}
});
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "9. Communications";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "10. Business Transaction";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "If Dollarbird Apps SRL is involved in a merger, acquisition or asset sale, your Personal Information may be transferred. We will provide notice before your Personal Information is transferred and becomes subject to a different Privacy Policy.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "11. Security";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We take certain measures to enhance the security of our Site and Service, including using SSL certificates and a one-way hashing algorithm for storing Users’ passwords. However, we make no representations as to the security or privacy of your information.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security. We recommend that you use anti-virus software, firewalls, and other precautions to protect yourself from security threats.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "12. International Transfer";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "If you are located outside Romania and choose to provide information to us, please note that we transfer the information, including Personal Information, to Romania and process it there.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "13. Links To Other Sites";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "14. Children's Privacy";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "Our Service does not address anyone under the age of 13 (\"Children\").";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you are aware that your Children has provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.";
}
});
pug_mixins["subtitle"].call({
block: function(){
pug_html = pug_html + "15. Contact Us";
}
});
pug_mixins["paragraph"].call({
block: function(){
pug_html = pug_html + "If you have any questions about these Policies, please contact us by sending an email to \u003Ca db-mail-to=\"$ctrl.salesEmail\" ng-bind=\"$ctrl.salesEmail\"\u003E\u003C\u002Fa\u003E.";
}
});
pug_mixins["footer"]("Aug 18, 2021");
pug_html = pug_html + "\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "rdqf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"link","disabled":"disabled","button":"button","button-block":"button-block","button-icon":"button-icon","icon":"icon","button-link":"button-link","button-danger":"button-danger","button-remove":"button-remove","button-add":"button-add","icon-dollarbird-plus":"icon-dollarbird-plus","button-fill":"button-fill","button-primary":"button-primary","button-secondary":"button-secondary","button-outline":"button-outline","readonly":"readonly","block-component":"block-component","icon-dollarbird-grip":"icon-dollarbird-grip","icon-dollarbird-multiple":"icon-dollarbird-multiple","icon-dollarbird-search":"icon-dollarbird-search","icon-dollarbird-delete":"icon-dollarbird-delete","icon-dollarbird-edit":"icon-dollarbird-edit","icon-dollarbird-users":"icon-dollarbird-users","icon-dollarbird-balance-update":"icon-dollarbird-balance-update","icon-dollarbird-transfer":"icon-dollarbird-transfer","icon-dollarbird-close":"icon-dollarbird-close","icon-dollarbird-settings":"icon-dollarbird-settings","icon-dollarbird-readonly":"icon-dollarbird-readonly","icon-dollarbird-premium":"icon-dollarbird-premium","icon-dollarbird-twitter":"icon-dollarbird-twitter","icon-dollarbird-facebook":"icon-dollarbird-facebook","icon-dollarbird-dashboard":"icon-dollarbird-dashboard","icon-dollarbird-menu":"icon-dollarbird-menu","icon-dollarbird-minus":"icon-dollarbird-minus","icon-dollarbird-name":"icon-dollarbird-name","icon-dollarbird-email":"icon-dollarbird-email","icon-dollarbird-password":"icon-dollarbird-password","icon-dollarbird-chevron-left":"icon-dollarbird-chevron-left","icon-dollarbird-chevron-right":"icon-dollarbird-chevron-right","icon-dollarbird-chevron-up":"icon-dollarbird-chevron-up","icon-dollarbird-chevron-down":"icon-dollarbird-chevron-down","icon-dollarbird-repeat":"icon-dollarbird-repeat","icon-dollarbird-arrow-left":"icon-dollarbird-arrow-left","icon-dollarbird-arrow-right":"icon-dollarbird-arrow-right","icon-dollarbird-checkmark":"icon-dollarbird-checkmark","icon-dollarbird-calendar":"icon-dollarbird-calendar","icon-dollarbird-details":"icon-dollarbird-details","legal-application":"legal-application","title":"title","subtitle":"subtitle","paragraph":"paragraph","list":"list","list-item":"list-item","footer":"footer"};

/***/ })

},[4]);


// WEBPACK FOOTER //
// asset/script-legal-6a3c49b53cdca347ead5.bundle.js